module.exports = __webpack_public_path__ + "img/propertysupervise2.07333bb0.png";